import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from '../../shared/components/layout/layout.component';
import { AdjusterDashboardComponent } from './adjuster-dashboard.component';
import { PayeeComponent } from './payee/payee.component';
import { BankingComponent } from '../claims/components/payee/components/banking/banking.component';
import { UnableToFulfillComponent } from '../../shared/components/unable-to-fulfill/unable-to-fulfill.component';
import { AuthGuard } from '@auth0/auth0-angular';
import { Auth0GuardService } from 'src/app/core/services/auth0-guard.service';
@NgModule({
  imports: [RouterModule.forChild([
    {
      path: '',
      component: LayoutComponent,
      children:[
      {
        path: '',
        component: AdjusterDashboardComponent,
        canActivate:[Auth0GuardService],
        children:[
          {
            path: '',
            component: PayeeComponent,
          },
          {
            path: 'bankInfo',
            component: BankingComponent
          },
          {
            path: 'unable-to-fulfill',
            component: UnableToFulfillComponent
          }
        ]
      }]
    }])
],
exports: [RouterModule]
})
export class AdjusterDashboardRoutingModule { }
